import {useEffect, useState} from "react";
import {useOktaAuth} from "@okta/okta-react";
import axios from "axios";
import config from "./config";

export function useUserLogin() {
    const {authState, authService} = useOktaAuth();
    const [userInfo, setUserInfo] = useState(null);
    const [userSessionObj, setUserSessionObj] = useState(null);

    const logout = async () => {
            authService.logout(config.logoutUrl);
    };

    const authAxios = axios.create({
        baseURL: config.apiBaseURI,
        headers: {
            Authorization: `Bearer ` + authState.accessToken,
            'content-type': 'application/json',
            'Accept': 'application/json'
        }
    });

    const getUserRoles = async (userID) => {
        try {
            return await authAxios.get(`/PDCReturn/loginCheck/` + userID);
        } catch (e) {
            console.error(e);
        }
    };
    const setSessionInfo = (session) => {
        sessionStorage.setItem("session", JSON.stringify(session));
    };

    const setSessionRoles = (roles) => {
        sessionStorage.setItem("roles",getRole(roles))
        sessionStorage.setItem('isAdminLogin', roles.isAdminLogin);
        sessionStorage.setItem('isRequestProcessor', roles.isRequestProcessor);
        sessionStorage.setItem('isParmteamMember', roles.isParmteamMember);
       
    };
    const getRole=(roles)=>{
        let roleToBeReturned="";
        if(roles.isAdminLogin){roleToBeReturned="Admin";}
        else if(roles.isRequestProcessor){roleToBeReturned="RequestProcessor";}
        else if(roles.isParmteamMember){roleToBeReturned="ParmteamMember";}
        else{roleToBeReturned="";}
        return roleToBeReturned;
    }
    const setUserObj = (info, roles) => {
        let userObj = {
            userId: info.userID,
            given_name:info.given_name,
            userName:
                info.lastName +
                ", " +
                info.firstName +
                (info.middleInitial !== undefined
                    ? " " + info.middleInitial
                    : ""),
            token: authState.accessToken,
            roles: getRole(roles),
            isCriteriaAdmin: roles.isAdminLogin,
            isRequestProcessor: roles.isRequestProcessor,
            isParmteamMember: roles.isParmteamMember,
            
        };
        setSessionInfo(userObj);
        setUserSessionObj(userObj)
    };

    useEffect(() => {
        if (!authState.isAuthenticated) {
            setUserInfo(null);
        } else {
            authService.getUser().then((info) => {
                if (info) {
                    setUserInfo(info);

                        getUserRoles(info.userID).then((roles) => {
                            if (roles) {
                                setUserObj(info, roles.data)
                                setSessionRoles(roles.data)
                            }
                        })
                }
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState, authService]);

    return [userInfo, logout, userSessionObj];
}

export function getSessionInfo() {
    let obj = sessionStorage.getItem("session");

    return obj === undefined || obj === null ? null : JSON.parse(obj);
}

export function getSessionRoles() {
    let obj = sessionStorage.getItem("roles");

    return obj === undefined || obj === null ? null : obj;
}
